import { useEffect } from 'react';

import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import { IFieldListResponse } from '../../api/types';
import { IField } from '../../types/my-types';
import useGlynt from './useGlynt';

import { getOffsetFromUrl } from '../../utils/getOffsetFromUrl';

function mergeResults(data: InfiniteData<IFieldListResponse> | undefined) {
  if (!data) return [];

  let results: IField[] = [];

  data.pages.map((page) => {
    results = results.concat(page.results);
    return true;
  });

  return results;
}

// get all fields from a training set
export default function useFields(trainingSetId: string) {
  const glynt = useGlynt();

  const { data, isError, isLoading, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: ['allFields', trainingSetId],
    queryFn: async ({ pageParam }) =>
      (await glynt).fields.list({
        advanced: true,
        training_set: trainingSetId,
        ordering: 'field_order',
        limit: 100,
        offset: pageParam,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.next) {
        return getOffsetFromUrl(lastPage.next);
      }
    },
    refetchOnWindowFocus: false,
    enabled: trainingSetId.length > 0,
  });

  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [data, hasNextPage, fetchNextPage]);

  const currentPage = data?.pages?.length ?? 0;
  const totalPages = data?.pages?.[0]?.count ? Math.ceil(data.pages[0].count / 100) : 0;

  if (isLoading || isFetching || isError || trainingSetId.length === 0) {
    return [];
  }

  return {
    currentPage,
    totalPages,
    data: mergeResults(data),
  };
}
